import React from 'react';
import { useResponsive } from '@parsina/framework';
import PrescriptionWeb from './Prescription.web.jsx';
import PrescriptionMobile from './Prescription.mobile.jsx';

// نسخه — two surfaces, one prescription.
//
// The desktop is a `minmax(0,1fr) 320px` two-column workspace with the drug
// list on the left and allergies/interactions in a right rail. A phone has no
// rail, so the order changes: allergies lead, the drug search is a
// `BottomSheet` rather than a popover, each medicine's four fields go one per
// row, and ثبت docks at the bottom.
//
// The BEHAVIOUR is identical and shared: `Prescription.shared.js` +
// `lib/prescription.js` own the sweep contract, the severity tints and the
// two-tap save phase, so the two surfaces cannot disagree about what is
// dangerous or about what reaches clinicalencounter.
const PrescriptionScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <PrescriptionMobile /> : <PrescriptionWeb />;
};

export default PrescriptionScreen;
